/**
 * MainBackground component
 */
import AccentMask from '@components/atoms/mask/accentMask';
import ContentMask from '@components/atoms/mask/sliderMask';
import DescriptionBackground from './descriptionBackground';
import MainBackgroundContainer from '@components/atoms/container/mainBackgroundContainer';

/**
 * This component displays several masks that cover the background of the app.
 */
export default function MainBackground() {
  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return (
    <MainBackgroundContainer>
      <DescriptionBackground />
      <ContentMask display={true} />
      <AccentMask />
    </MainBackgroundContainer>
  );
}
